/** Global header site scope — matches API `site_id` when aggregating. */
export const ALL_SITES_ID = "all";

/** Last concrete site chosen on per-site config pages (session). */
export const LAST_SINGLE_SITE_STORAGE_KEY = "layerd:lastSingleSiteId";

export function isAllSites(siteId) {
  return !siteId || siteId === ALL_SITES_ID;
}

/** Routes where the UI needs one site (not “All sites”) in the header. */
const SINGLE_SITE_SCOPE_PREFIXES = [
  "/v2/services/",
  "/v2/csp/",
  "/v2/api-security",
];

export function requiresSingleSiteScopePath(pathname) {
  if (!pathname) return false;
  return SINGLE_SITE_SCOPE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix)
  );
}

export function rememberSingleSiteId(siteId) {
  if (isAllSites(siteId)) return;
  try {
    sessionStorage.setItem(LAST_SINGLE_SITE_STORAGE_KEY, siteId);
  } catch {
    // ignore
  }
}

/**
 * Pick a default site when a page requires a single scope: last selected in
 * session, else first site in the current project list.
 */
export function pickDefaultSiteId(siteOptions) {
  if (!siteOptions?.length) return null;
  try {
    const last =
      sessionStorage.getItem(LAST_SINGLE_SITE_STORAGE_KEY) ||
      localStorage.getItem("curSiteId");
    if (last && !isAllSites(last) && siteOptions.some((s) => s?.site_id === last)) {
      return last;
    }
  } catch {
    // ignore
  }
  return siteOptions[0]?.site_id ?? null;
}
